module.exports = __webpack_public_path__ + "img/BJE-axcent_crystal_slim_koralle_weiss_matt.c7a70062.png";